import type { EntryPoint, EntryPointComponent, PreloadFetchPolicy } from 'react-relay';

import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

import { createQueryContextCacheConfig } from '../../common/utils/query-context-headers';

import parameters, {
	type AsyncTeamSelectorQuery,
} from './__generated__/AsyncTeamSelectorQuery.graphql';
import type {
	AsyncTeamSelectorEntryPointProps,
	AsyncTeamSelectorWithQueryProps,
} from './AsyncTeamSelector';

type EntryPointParams = { containerId: string; cloudId: string };
const fetchPolicy: PreloadFetchPolicy = 'network-only';

type AsyncTeamSelectorEntryPointComponent = EntryPointComponent<
	{
		getTeamsForContainerQuery: AsyncTeamSelectorQuery;
	},
	Record<string, never>,
	AsyncTeamSelectorEntryPointProps,
	AsyncTeamSelectorWithQueryProps
>;

export const asyncTeamSelectorEntryPoint: EntryPoint<
	AsyncTeamSelectorEntryPointComponent,
	EntryPointParams
> = createEntryPoint({
	root: JSResourceForInteraction<AsyncTeamSelectorEntryPointComponent>(
		/* webpackChunkName: "@atlaskit-internal_@atlassian/teams/team-selector" */ './AsyncTeamSelector',
		{
			moduleId: 'team-selector-entrypoint',
		},
	),
	getPreloadProps: ({ containerId, cloudId }: EntryPointParams) => {
		const networkCacheConfig = createQueryContextCacheConfig(cloudId);
		return {
			queries: {
				getTeamsForContainerQuery: {
					parameters,
					variables: {
						containerId,
					},
					options: {
						fetchPolicy,
						...(networkCacheConfig && { networkCacheConfig }),
					},
				},
			},
			extraProps: { containerId },
		};
	},
});
